/* Shared, on-demand format chooser. Shopify remains the source of prices and stock. */
(() => {
  if (window.brQuickAddReady || !window.HTMLDialogElement) return;
  window.brQuickAddReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const dialog = document.createElement('dialog');
  dialog.id = 'br-quick-add';
  dialog.setAttribute('aria-labelledby', 'br-qa-title');
  dialog.innerHTML = `<button type="button" class="br-qa-close" aria-label="Fermer le choix du format">×</button>
    <div class="br-qa-head"><img class="br-qa-image" alt="" width="84" height="112" hidden><div><p class="br-qa-kicker">À votre mesure</p><h2 id="br-qa-title">Choisir le format</h2><a class="br-qa-detail">Voir l’affiche en détail</a></div></div>
    <fieldset class="br-qa-options"><legend>Votre format</legend><div class="br-qa-choices"></div></fieldset>
    <p class="br-qa-status" role="status" aria-live="polite"></p>
    <button type="button" class="br-qa-submit" disabled>Choisissez un format</button>
    <div class="br-qa-success" hidden><a class="br-qa-cart">Voir mon panier</a><button type="button" class="br-qa-continue">Continuer ma sélection</button></div>`;
  document.body.append(dialog);
  const $ = s => dialog.querySelector(s);
  const choices = $('.br-qa-choices'), status = $('.br-qa-status'), submit = $('.br-qa-submit');
  const success = $('.br-qa-success'), image = $('.br-qa-image');
  $('.br-qa-cart').href = root + 'cart';
  let opener, selected, product, busy = false, generation = 0, uncertain = false;
  const sizes = {
    '8.2" x 11.6" (Vertical)': 'A4 (20,8 × 29,5 cm)',
    '11.6" x 16.5" (Vertical)': 'A3 (29,5 × 41,9 cm)',
    '16.5" x 23.3" (Vertical)': 'A2 (41,9 × 59,2 cm)',
    '23.3" x 33.1" (Vertical)': 'A1 (59,2 × 84,1 cm)',
    '11.6" x 8.2" (Horizontal)': 'A4 (29,5 × 20,8 cm)',
    '16.5" x 11.6" (Horizontal)': 'A3 (41,9 × 29,5 cm)',
    '23.3" x 16.5" (Horizontal)': 'A2 (59,2 × 41,9 cm)',
    '33.1" x 23.3" (Horizontal)': 'A1 (84,1 × 59,2 cm)',
    'Matte': 'Mat', 'Default Title': 'Format unique'
  };
  const label = title => window.brFormatLabel(Object.entries(sizes).reduce((s, [a, b]) => s.split(a).join(b), title));
  const money = n => new Intl.NumberFormat('fr-FR', {style:'currency', currency:window.Shopify?.currency?.active || 'EUR'}).format(n / 100);
  async function requestJSON(url, options, timeoutMs) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url, {...options, signal:controller.signal});
      return {ok:response.ok, data:response.ok ? await response.json() : null};
    } finally { clearTimeout(timer); }
  }
  function close() { dialog.close(); }
  function closeCartDrawer() {
    // The installed cart app opens after Ajax additions. Its own close control restores page scrolling.
    document.querySelector('#qikify-stickycart-v2-app .qsc2-drawer-header__close-button')?.click();
  }
  $('.br-qa-close').addEventListener('click', close);
  $('.br-qa-continue').addEventListener('click', close);
  dialog.addEventListener('close', () => { generation++; closeCartDrawer(); opener?.focus({preventScroll:true}); });
  dialog.addEventListener('click', e => {
    const r = dialog.getBoundingClientRect();
    if (e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) close();
  });
  // Capture only this action before card/app navigation handlers.
  window.addEventListener('click', async e => {
    const trigger = e.target.closest('[data-br-quick-add]');
    if (!trigger || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    opener = trigger; selected = null; product = null; uncertain = false;
    const current = ++generation;
    choices.replaceChildren(); success.hidden = true; submit.hidden = false; submit.disabled = true;
    submit.textContent = 'Choisissez un format'; status.textContent = 'Chargement des formats…'; image.hidden = true;
    $('.br-qa-options').disabled = false;
    $('#br-qa-title').textContent = 'Choisir le format'; $('.br-qa-detail').href = trigger.dataset.brProductUrl || trigger.href;
    dialog.showModal(); $('.br-qa-close').focus();
    try {
      const response = await requestJSON(root + 'products/' + encodeURIComponent(trigger.dataset.brQuickAdd) + '.js', {credentials:'same-origin', cache:'no-store'}, 12000);
      if (!response.ok) throw new Error('product');
      const data = response.data;
      if (current !== generation || !dialog.open) return;
      product = data; $('#br-qa-title').textContent = data.title;
      if (data.featured_image) {
        const url = new URL(data.featured_image, location.origin); url.searchParams.set('width','168');
        image.src = url.href; image.hidden = false;
      }
      data.variants.forEach(v => {
        const item = document.createElement('label'); item.className = 'br-qa-option';
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'br-qa-variant'; radio.value = v.id; radio.disabled = !v.available;
        const text = document.createElement('span'); text.textContent = label(v.title);
        const price = document.createElement('strong'); price.textContent = v.available ? money(v.price) : 'Indisponible';
        item.append(radio, text, price); choices.append(item);
        radio.addEventListener('change', () => {
          selected = v; success.hidden = true; submit.hidden = false; submit.disabled = uncertain;
          submit.textContent = 'Ajouter au panier · ' + money(v.price); status.textContent = '';
        });
      });
      status.textContent = data.variants.some(v => v.available) ? 'Choisissez le format qui vous convient.' : 'Cette affiche est momentanément indisponible.';
    } catch (_) {
      if (current === generation) status.textContent = 'Les formats ne se chargent pas. Retrouvez-les sur la fiche de l’affiche.';
    }
  }, true);
  submit.addEventListener('click', async () => {
    if (!selected || busy || uncertain || submit.disabled) return;
    busy = true; submit.disabled = true; $('.br-qa-options').disabled = true;
    submit.textContent = 'Ajout en cours…'; status.textContent = '';
    const variant = selected;
    try {
      const response = await requestJSON(root + 'cart/add.js', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:variant.id, quantity:1}]})
      }, 20000);
      if (!response.ok) {
        // A failed response can follow a partial stock adjustment: invite a cart check first.
        status.textContent = 'L’ajout n’a pas pu être confirmé. Vérifiez votre panier et la disponibilité de ce format.';
        uncertain = true; success.hidden = false; submit.hidden = true; return;
      }
      const result = response.data;
      if (!result.items?.some(i => String(i.variant_id || i.id) === String(variant.id))) throw new Error('unconfirmed');
      status.textContent = label(variant.title) + ' : ajouté à votre panier.';
      success.hidden = false; submit.hidden = true;
      if (dialog.open) $('.br-qa-cart').focus(); else closeCartDrawer();
    } catch (_) {
      uncertain = true; submit.hidden = true; success.hidden = false;
      status.textContent = 'La connexion a été interrompue. Vérifiez votre panier avant de renouveler l’ajout.';
    } finally {
      busy = false; $('.br-qa-options').disabled = uncertain;
    }
  });
})();
